export const JAEGER_TAG_FIELD = 'JaegerTag';
//# sourceMappingURL=jaeger-tag-field.js.map